import React from 'react';

export function Radio({
  labelClass,
  checked,
  children,
  onChange = () => {},
  name,
  value,
  ...props
}) {
  return (
    <div className="custom-radio" role="presentation">
      <label className={labelClass}>
        <input
          type="radio"
          checked={checked ?? false}
          onChange={onChange}
          name={name}
          value={value}
          {...props}
        />
        <span className="decorator">
          <span className="decorator-dot" />
        </span>
        {children}
      </label>
    </div>
  );
}

export default Radio;
